const STUDY_TARGET_KIND = {
	LEARN_ALL_THE_QUESTIONS: 1, // 全問題を学習
	LEARN_UNANSWERED_QUESTIONS: 2, // 未正解の問題だけ学習
	LEARN_REVIEW_REQUIRED_QUESTIONS: 3, // 要復習問題だけ学習
	CHECK_RESULT_PREVIOUS_STUDY: 4, // 前回の学習結果を確認
	LEARN_REVIEW_TAG_NEXT_QUESTION: 5, // 要復習問題学習結果画面の「次の○問」からS3-4へ遷移して続きを開始
}

const REVIEW_REQUIRED = {
	NOT_REVIEW_REQUIRED: 1, //  要復習ではない
	QUESTION_SET_REVIEW: 2, // 出題単位の要復習をまとめて学習
	SECTION_REVIEW: 3, // 孫項目の要復習をまとめて学習
	CHAPTER_REVIEW: 4, // 子項目の要復習をまとめて学習
}

const DISABLED_BUTTON_TIME = 500 // 学習画面の青いボタンの活性化するまでの遅延時間

const FOCUS_DELAY_TIME = 100 // Answer画面で非活性化されたボタンが活性化するまでボタンのフォーカスを遅延する時間

const MAX_TRANSITION_TIME = 5000 // Question to Answer or Judge page transition max time 

const COMPOSING_CHECK_TIME = 100 // NFR-4550 日本語入力中フラグが完了になってるかチェックするinterval設定時間

const COMPOSING_TIMEOUT = 5000 // NFR-4550 日本語入力中フラグが完了まで最大待ってるタイムアウト時間, NFR-4610 2秒から5秒に変更

export {
    STUDY_TARGET_KIND, DISABLED_BUTTON_TIME, FOCUS_DELAY_TIME, MAX_TRANSITION_TIME, COMPOSING_CHECK_TIME, COMPOSING_TIMEOUT, REVIEW_REQUIRED
}
